<template>
  <b-container fluid
               class="px-0">
    <div class="d-flex">
      <sidebar class="esg-sidebar"/>
      <div class="esg-main">
        <top-bar class="esg-top-bar"/>
        <keep-alive :max="2" :include="/List$/">
          <router-view class="esg-router-view"
                       :key="$route.path"/>
        </keep-alive>
      </div>
    </div>
  </b-container>
</template>

<script>
import TopBar from '@/components/esg/layout/EsgTopBar.vue'
import Sidebar from "@/components/esg/layout/EsgSideBar.vue";

export default {
  components: {TopBar, Sidebar},
}
</script>

<style scoped>
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

>>> *, * {
  font-family: NanumGothic, serif !important;
}

>>> .esg-sidebar .b-sidebar-outer {
  z-index: 490;
}

.esg-main {
  width: 80vw;
  height: 100dvh;
  overflow-y: auto;
  background-color: #F6F6FA;
  position: fixed;
  left: 20vw;
  z-index: 500;

  display: flex;
  flex-direction: column;
}

.esg-top-bar {
  position: sticky;
  height: max(82px, 10dvh);
  top: 0;
  z-index: 1100; /** make greater than loading spinner's z-index, 1000 **/
}

.esg-router-view {
  background-color: #F6F6FA;
  flex-grow: 1;
}

@media (max-width: 1250px) {
  .esg-main {
    position: static;
    width: 100vw;
  }

  >>> .esg-sidebar .b-sidebar-outer {
    z-index: 510;
  }
}
</style>

<style scoped>
/** ESG 전역 CSS **/
>>> .btn-container {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1.333rem 3.125vw;
  gap: 0.666rem;
  align-items: center;
  z-index: 999;
  background-color: #f6f6fa;
  box-shadow: 0 -10px 30px 0 rgba(46, 46, 56, 0.14);
}

>>> .btn-wrap {
  white-space: nowrap;
  overflow: visible;
  display: flex;
  gap: 1rem;
}

>>> .btn-container .btn-wrap button {
  width: 100px;
}

>>> .form-row > [class*="col-"] {
  margin-bottom: unset;
}
</style>